import React from "react";
import "./Footer.css";

import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import InstagramIcon from "@mui/icons-material/Instagram";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="footer-logo">
          <img src="/haqdarshak.png" alt="Haqdarshak Logo" className="logo-image" />
        </div>
        <div className="footer-mission">
          Empowering citizens by making welfare accessible, inclusive, and tech-enabled.
        </div>
      </div>

      <div className="footer-socials">
        <a href="https://www.facebook.com/haqdarshak" target="_blank" rel="noopener noreferrer">
          <FacebookIcon /> Facebook
        </a>
        <a href="https://x.com/haqdarshak" target="_blank" rel="noopener noreferrer">
          <TwitterIcon /> Twitter
        </a>
        <a href="https://www.instagram.com/haqdarshak/" target="_blank" rel="noopener noreferrer">
          <InstagramIcon /> Instagram
        </a>
      </div>

      <div className="footer-contact">
        <p><strong>Website:</strong> <a href="https://haqdarshak.com" target="_blank" rel="noopener noreferrer">www.haqdarshak.com</a></p>
        <p><strong>Contact Us:</strong> <a href="mailto:contactus@haqdarshak.com">contactus@haqdarshak.com</a> </p>
      </div>

      <div className="footer-copy">
        © {new Date().getFullYear()} Haqdarshak Empowerment Solutions Pvt. Ltd. All rights reserved.
      </div>

      <div className="footer-data-contact">
        Please reach out to <a href="mailto:data@haqdarshak.com">data@haqdarshak.com</a> for your data or insights needs.
      </div>
    </footer>
  );
};

export default Footer;
